// Components
import InputBase from "@mui/material/InputBase";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// Styles
import styled from "@emotion/styled";

const BootstrapInput = styled(InputBase)(() => ({
  "& .MuiInputBase-input": {
    height: "40px !important",
    minHeight: "40px",
    borderRadius: "4px",
    position: "relative",
    border: "none",
    fontSize: "16px",
    padding: "0px 16px",
    backgroundColor: "#E5E9ED",
    color: "#202338",
    boxShadow: "none",
    display: "flex",
    alignItems: "center",
  },
}));

const SelectDropdown = ({
  disabled = false,
  required = false,
  dropdownOptions,
  value,
  handleChange,
}) => {
  return (
    <Select
      id="search-input-dropdown"
      variant="outlined"
      color="warning"
      disabled={disabled}
      required={required}
      value={value}
      onChange={handleChange}
      input={<BootstrapInput />}
      fullWidth
      MenuProps={{
        MenuListProps: { sx: { maxHeight: "200px", overflow: "auto" } },
        PaperProps: {
          sx: {
            marginTop: "8px",
            maxHeight: "200px",
            overflow: "hidden",

            "& .MuiMenuItem-root.Mui-selected": {
              backgroundColor: "#48BECB20",
            },
            "& .MuiMenuItem-root:hover": {
              backgroundColor: "#E2772E20",
            },
            "& .MuiMenuItem-root.Mui-selected:hover": {
              backgroundColor: "#E2772E20",
            },
          },
        },
      }}
    >
      {dropdownOptions.map((option, index) => (
        <MenuItem key={index} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SelectDropdown;
